import { connect } from 'react-redux';
import I18n from '../../../config/i18n';
import { formatNumber } from '../../../utils/Formatter';

import './ReviewHeaderLine.css';

const reviewMaxScore = 5;

interface ReviewHeaderLineComponentProps {
  avgRatingOverall: number;
  totalEntries: number;
  linkTarget?: string;
}

export function ReviewHeaderLineComponent({
  avgRatingOverall,
  totalEntries,
  linkTarget,
}: ReviewHeaderLineComponentProps): JSX.Element | null {
  if (avgRatingOverall === undefined) {
    return null;
  }

  function wrapInLink(children: JSX.Element) {
    if (!linkTarget) {
      return children;
    }
    return <a href={linkTarget}>{children}</a>;
  }

  return (
    <div className="review-header-line">
      {wrapInLink(
        <span>
          <span className="review-header-line__star">
            <i className="fa fa-star" aria-hidden />
          </span>{' '}
          <span className="review-header-line__rating">
            {formatNumber(avgRatingOverall, { precision: 2 })}/
            {formatNumber(reviewMaxScore, { precision: 2 })}
          </span>{' '}
          ({totalEntries} {I18n.t('accommodation_reviews.reviews', { count: totalEntries })})
        </span>,
      )}
    </div>
  );
}

const defaultProps: Pick<ReviewHeaderLineComponentProps, 'linkTarget'> = {
  linkTarget: undefined,
};

ReviewHeaderLineComponent.defaultProps = defaultProps;

function mapStateToProps({ accommodationReviews }: any) {
  if (
    !accommodationReviews ||
    !accommodationReviews.avgRatings ||
    !accommodationReviews.pagination
  ) {
    return {};
  }
  return {
    avgRatingOverall: accommodationReviews.avgRatings.avgRatingOverall,
    totalEntries: accommodationReviews.pagination.totalEntries,
  };
}

export default connect(mapStateToProps)(ReviewHeaderLineComponent);
